var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2103 150.2C116.687 150.2 150.31 116.577 150.31 75.1C150.31 33.6234 116.687 0 75.2103 0C33.7338 0 0.110352 33.6234 0.110352 75.1C0.110352 116.577 33.7338 150.2 75.2103 150.2Z",
    fill: "url(#paint0_linear_339_495)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2101 133.23C107.314 133.23 133.34 107.204 133.34 75.1C133.34 42.9957 107.314 16.97 75.2101 16.97C43.1058 16.97 17.0801 42.9957 17.0801 75.1C17.0801 107.204 43.1058 133.23 75.2101 133.23Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3896 57.55H90.9496V61.44H59.3896V57.55Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9405 53.66V45.89H100.66V42H47.7305V45.89H51.6205V55.6H55.5105V45.89H59.4005V53.66H90.9605H90.9405Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6005 75.1701C94.6005 71.6601 93.6805 68.3001 91.9205 65.3201H58.4105C56.6505 68.2901 55.7305 71.6501 55.7305 75.1701C55.7305 80.8401 58.2105 86.1601 62.4005 89.8101H73.2205V78.0501L68.2905 73.1201L71.0405 70.3701L75.1605 74.4901L79.2805 70.3701L82.0305 73.1201L77.1005 78.0501V89.8101H87.9205C92.1105 86.1601 94.5905 80.8401 94.5905 75.1701H94.6005Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7402 93.6899V97.8999C64.7402 103.65 69.4202 108.33 75.1702 108.33C80.9202 108.33 85.6002 103.65 85.6002 97.8999V93.6899H64.7402Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2803 62.9199L45.9203 59.3999L53.0803 62.7399L51.4403 66.2599L44.2803 62.9199Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 73.22H49.9V77.11H42V73.22Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2998 87.4101L51.4598 84.0701L53.0998 87.5901L45.9398 90.9301L44.2998 87.4101Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.25 87.6401L98.89 84.1201L106.05 87.4601L104.41 90.9801L97.25 87.6401Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.43 73.22H108.33V77.11H100.43V73.22Z",
    fill: "#05A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2305 62.7001L104.39 59.3601L106.03 62.8801L98.8705 66.2201L97.2305 62.7001Z",
    fill: "#05A2E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_495",
    x1: 18.6704,
    y1: 124.52,
    x2: 130.84,
    y2: 26.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#12A8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#38BBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#56CAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6BD4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#78DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DDDFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.33,
    height: 66.33,
    fill: "white",
    transform: "translate(42 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission02);
export default __webpack_public_path__ + "static/media/Mission-02.40c61f6e416d5856b59b3b60691ed2ef.svg";
export { ForwardRef as ReactComponent };